import { memo, useMemo } from 'react';
import { StyleSheet, View } from 'react-native';

import { tokens } from '@fhs/ui';

import { useCartValues } from '../../../state/cart-store';
import CartItem from '../item';

function CartItemsList() {
  const { cartEntries } = useCartValues();

  const filteredCartEntries = useMemo(
    () => cartEntries.filter(entry => !entry.isDonation),
    [cartEntries]
  );

  return (
    <View
      style={styles.container}
      accessibilityRole="list"
      accessibilityLabel={`Cart items list: ${filteredCartEntries.length} ${filteredCartEntries.length === 1 ? 'item' : 'items'}`}
    >
      {filteredCartEntries.map(item => (
        <CartItem key={item.lineId} item={item} />
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    borderTopWidth: 1,
    borderTopColor: tokens.colors.$blackOpacity10,
    width: '100%',
    padding: 16,
  },
});

export default memo(CartItemsList);
